import { forwardRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {isNavigationDestination} from './navigation.js';

/** Route actions remain links, preserving query strings and browser link actions. */
export const LinkButton = forwardRef(function LinkButton({ variant = 'primary', size = 'standard', className = '', children, ...props }, ref) {
  return <Link {...props} ref={ref} className={`fc-button fc-button--${variant} fc-button--size-${size} ${className}`}><span className="fc-button__label">{children}</span></Link>;
});
export function NavigationLink({ to, className = '', children, ...props }) {
  const location = useLocation();
  const destination = typeof to === 'string' ? to.split('?')[0] : to?.pathname;
  return <Link {...props} to={to} aria-current={isNavigationDestination(location.pathname, destination) ? 'page' : undefined}
    className={`fc-nav-link ${className}`}>{children}</Link>;
}
export function Card({ as: Element = 'div', className = '', padding = 'standard', children, ...props }) {
  return <Element {...props} className={`fc-card fc-card--${padding} ${className}`}>{children}</Element>;
}
export function Table({ label = 'Data table', caption, className = '', children, ...props }) {
  // The scroll region must hide along with a mobile/desktop table variant.
  const visibility = className.split(/\s+/).filter(c => /^(hidden|(?:sm|md|lg|xl):(?:hidden|table))$/.test(c));
  const tableClasses = className.split(/\s+/).filter(c => !visibility.includes(c)).join(' ');
  return <div className={`fc-table-scroll ${visibility.map(c => c.replace(':table', ':block')).join(' ')}`} role="region" aria-label={caption || label} tabIndex={0}>
    <table {...props} className={`fc-table ${tableClasses}`}>{caption && <caption>{caption}</caption>}{children}</table>
  </div>;
}
